var Flickity = require('flickity');

const splashSlider = jQuery('.splash__half'),
    splashSlides = jQuery('.splash__half .splash')

let splashVideoPrev
let carousel

if (splashSlider.length > 0 && splashSlides.length > 1) {

        carousel = new Flickity('.splash__half',{
        prevNextButtons: false,
        cellSelector: '.splash',
        wrapAround: true,
        pageDots: true,
        resize: true,
        cellAlign: 'left',
        autoPlay: false,
        arrowShape: {
            x0: 10,
            x1: 60, y1: 50,
            x2: 65, y2: 45,
            x3: 20
        }
    })

    // previous
    jQuery('.button--previous').on( 'click', function() {
      carousel.previous();
    });
    // next
    jQuery('.button--next').on( 'click', function() {
      carousel.next();
    });

   var carouselStatus = document.querySelector('.carousel-status');

    function updateStatus() {
        var slideNumber = carousel.selectedIndex + 1;
        carouselStatus.textContent = slideNumber + '/' + splashSlides.length;
    }
    updateStatus();
    carousel.on( 'select',  updateStatus );
    // splashSlider.on( 'select.flickity', updateStatus );

}
